var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box bar-chart"},[_c('database-not-found',{directives:[{name:"show",rawName:"v-show",value:(_vm.noData),expression:"noData"}],staticClass:"bar-area"}),_c('div',{ref:"title",staticClass:"bar-area"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }